export function displayName(c: { description?: string | null; customer_tag: string }): string {
  const desc = c.description?.trim();
  return desc || c.customer_tag;
}
